module.exports = __webpack_public_path__ + "img/poulain.f08b390c.jpg";